import intl from 'react-intl-universal';
import { Tooltip, Icon, tailwindOverride } from '@getsynapse/design-system';

const EditableTasksCountTooltip = () => {
  return (
    <Tooltip
      trigger={
        <div className='flex items-center'>
          <Icon
            name='alert-circle'
            aria-label='editable-tasks-count-tooltip-icon'
            className='text-neutral-light w-5 h-5'
          />
        </div>
      }
      ariaId='editable-tasks-count-tooltip'
      openMode='hover2'
      timeout={0}
      position='topCenter'
      contentProps={{
        className: tailwindOverride(
          'w-56 mb-2 p-3',
          'text-neutral-white text-sm',
          'bg-neutral-darker'
        ),
      }}
      showPopper
    >
      {intl.get('TASKS.BULK_ACTIONS.EDITABLE_TASKS_COUNT_TOOLTIP')}
    </Tooltip>
  );
};

export default EditableTasksCountTooltip;
